module.exports = __webpack_public_path__ + "img/grupo-carter.05e56177.png";